'use client';

import React from 'react';

import { Svg } from '@ui/svg';
import { cn } from '@/utilities/cn';

export const Phone: React.FC<{
  phone: string | undefined;
  className?: string;
}> = ({ phone, className }) => {
  if (!phone) {
    return null;
  }

  return (
    <div
      className={cn(
        'flex-center h7 link-secondary text-blue h-10 w-fit gap-1 rounded-full border border-gray-700 p-[3px] pr-[11px] lg:h-8 lg:pr-2',
        className,
      )}
    >
      <div className="flex-center aspect-square w-8 rounded-full bg-gray-700 lg:w-6">
        <Svg className="lg:w-3" id="phone" width="16" height="16" />
      </div>
      <a href={`tel:${phone}`}>{phone}</a>
      <span className="mx-[3px] h-6 w-px bg-[#D9D9D9] lg:mx-px lg:h-4" />
      <span className="ps text-gray-300">24/7</span>
    </div>
  );
};
